import { RootState } from '../../config';
import { IAuthState } from './types';

export const selectAuth = (state: RootState): IAuthState => state.auth;
